import useAuth from "app/hooks/useAuth";
import { NewLogo3 } from "Assets";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import "../../../../Assets/css/custom.css";
import "../../../../Assets/css/style.css";
import "../../../../Assets/css/web.css";
// import "../../../../Assets/css/bootstrap.min.css";

const Header = () => {
  const location = useLocation();
  const [colorChange, setColorchange] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const handleLogOut = () => {
    logout();
  };

  const changeNavbarColor = () => {
    if (window.scrollY >= 120) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);

  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <Link className="navbar-brand" to="/">
            <img src={NewLogo3} alt="" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className="toggle-wrap">
                <span className="toggle-bar"></span>
              </span>
            </span>
          </button>

          <div
            // className="collapse navbar-collapse"
            // id="navbarSupportedContent"
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/contact-us"
                  preventScrollReset={true}
                >
                  Contact Us
                </Link>
              </li>

              {location.pathname !== "/vendor" && (
                <li className="nav-item">
                  <div className="btn_block gray">
                    <Link
                      className="nav-link dark_btn"
                      to="/vendor"
                      preventScrollReset={true}
                    >
                      For Business
                    </Link>
                    <div className="btn_bottom"></div>
                  </div>
                </li>
              )}
              {location.pathname !== "/login" && (
                <li className="nav-item">
                  {isAuthenticated ? (
                    user?.data?.turf_count === 0 ? (
                      <div className="btn_block">
                        <Link
                          to="/"
                          className="nav-link dark_btn orange logout-button "
                          onClick={() => handleLogOut()}
                          style={{ marginLeft: "15px !important" }}
                        >
                          Logout
                        </Link>
                      </div>
                    ) : (
                      <Link
                        className="nav-link dark_btn orange"
                        to="/vendor-dashboard"
                      >
                        Vendor Dashboard
                      </Link>
                    )
                  ) : (
                    <li className="nav-item">
                      <div className="btn_block">
                        <Link className="nav-link dark_btn orange" to="/login">
                          Login
                        </Link>
                        <div className="btn_bottom orange-border" />
                      </div>
                    </li>
                  )}
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
